module.exports = __webpack_public_path__ + "static/media/Montserrat-VariableFont_wght.a3fcdff0.ttf";